import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'search-state',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loading) {
      <div class="circular-progress-container">
        <forge-circular-progress aria-label="Circular Progress" slot="graphic"></forge-circular-progress>
      </div>
    } @else {
      <forge-page-state>
        <img src="https://cdn.forge.tylertech.com/v1/images/spot/no-search-results-spot.svg" alt="" slot="graphic" />
        <div slot="title">Sorry, there were no matching results found...</div>
      </forge-page-state>
    }
  `,
  styles: [`
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .circular-progress-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 512px;
      width: 100%;
    }
    forge-circular-progress {
      width: 90px;
      height: 90px;
    }
    forge-page-state {
      margin: 64px auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100%;
    }
  `],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SearchStateComponent {
  @Input() loading = false;
}